import { Injectable, OnDestroy, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Subject, takeUntil } from 'rxjs';

interface PaginatorLabels {
  itemsPerPage: string;
  next: string;
  previous: string;
  first: string;
  last: string;
}

@Injectable()
export class TranslocoMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private transloco = inject(TranslocoService);
  private destroy$ = new Subject<void>();

  constructor() {
    super();
    this.transloco
      .selectTranslateObject<PaginatorLabels>('shared.paginator')
      .pipe(takeUntil(this.destroy$))
      .subscribe((labels) => {
        this.applyLabels(labels);
        this.changes.next();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.transloco.translate('shared.paginator.range.empty', { length });
    }
    const safeLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < safeLength ? Math.min(startIndex + pageSize, safeLength) : startIndex + pageSize;
    return this.transloco.translate('shared.paginator.range.of', {
      start: startIndex + 1,
      end: endIndex,
      length: safeLength,
    });
  };

  private applyLabels(labels: PaginatorLabels): void {
    this.itemsPerPageLabel = labels.itemsPerPage;
    this.nextPageLabel = labels.next;
    this.previousPageLabel = labels.previous;
    this.firstPageLabel = labels.first;
    this.lastPageLabel = labels.last;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
